import { styled } from '@mui/material/styles'
import { FC } from 'react'
import {
  Datagrid,
  List,
  ListProps,
  DateField,
  FunctionField,
  useTranslate,
  CreateButton,
} from 'react-admin'
import { CertificateOut } from '../../types/apiRequests'
import StatusChip from '../../components/StatusChip'
import ValidityChip from './CertificateValidityChip'
import { getCommonName } from '../../utils/getCommonName'
import { getKoppelvlak } from '../../utils/getKoppelvlak'
import { getInstance } from '../../utils/getInstance'
import { ListActionsToolbar, RestrictedButton } from '../../components'
import { CERTIFICATE_WRITE_SCOPE } from '../../config'

const CertificatesList: FC<ListProps> = (props) => {
  const translate = useTranslate()

  return (
    <StyledList
      {...props}
      exporter={false}
      actions={
        <ListActionsToolbar i18n="resources.certificates.list">
          <RestrictedButton
            access={[CERTIFICATE_WRITE_SCOPE]}
            align="right"
            className={classes.spacer}
          >
            {(): JSX.Element => <CreateButton variant="contained" />}
          </RestrictedButton>
        </ListActionsToolbar>
      }
    >
      <Datagrid bulkActionButtons={false} rowClick="show">
        <DateField
          source="created"
          label="data.created"
          options={{
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          }}
        />
        <FunctionField
          label="resources.certificates.fields.targetSystem"
          render={(record: CertificateOut) =>
            record?.targetSystem ? translate(`resources.certificates.targetSystems.${record.targetSystem?.toLocaleLowerCase()}`) : ''
          }
        />
        <FunctionField
          label="resources.certificates.fields.type"
          render={(record: CertificateOut) =>
            record?.type ? translate(`resources.certificates.types.${record.type}`) : ''
          }
        />
        <FunctionField
          label="resources.certificates.fields.instance"
          render={(record: CertificateOut) => getInstance(record)}
        />
        <FunctionField
          label="resources.certificates.fields.interface"
          render={(record: CertificateOut) => getKoppelvlak(record)}
        />
        <FunctionField
          label="data.adres"
          render={(record: CertificateOut) => getCommonName(record)}
        />
        <FunctionField
          label="resources.certificates.fields.status"
          render={() => <StatusChip listView/>}
        />
        <FunctionField
          label="resources.certificates.fields.geldigheid"
          render={() => <ValidityChip />}
        />
      </Datagrid>
    </StyledList>
  )
}

const PREFIX = 'xxllncCertificatesList'
const classes = {
  spacer: `${PREFIX}-spacer`,
}

const StyledList = styled(List)(({ theme }) => ({
  [`& .${classes.spacer}`]: {
    marginLeft: theme.spacing(1),
  },
}))

export default CertificatesList
